module.exports = __webpack_public_path__ + "img/find_documents.11573ef9.svg";